/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// TODO: Reenable commented code when the component is ready to be used

// Core imports
import { Fragment } from 'react';

// Component imports
import { Col, Row } from 'antd';
import OrganizationAnalytics from '../components/Analytics/OrganizationAnalytics';

/**
 * Public screen for organization analytics, can be embedded in an iFrame
 */
const AnalyticsPublicScreen = () => {
  return (
    <Fragment>
      <Row
        justify="center"
        className="p-6"
      >
        <Col span={24}>
          <OrganizationAnalytics />
        </Col>
      </Row>
    </Fragment>
  );
};

export default AnalyticsPublicScreen;
